// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Products from './pages/Products';
import ContactUs from './pages/ContactUs';
import Cart from './pages/Cart';
import ScrollRestoration from './components/ScrollRestoration'; // Import our comprehensive solution

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);

  // Add global style to hide scrollbars
  useEffect(() => {
    // Create a style element
    const style = document.createElement('style');
    
    // CSS to hide scrollbars across browsers while maintaining scroll functionality
    style.textContent = `
      /* Hide scrollbar for Chrome, Safari and Opera */
      ::-webkit-scrollbar {
        display: none;
      }
      
      /* Hide scrollbar for IE, Edge and Firefox */
      html, body {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        overflow-y: scroll;
        scroll-behavior: auto; /* Override any smooth scrolling */
      }
      
      /* Make sure all elements inherit these properties */
      * {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      
      *::-webkit-scrollbar {
        display: none;
      }
    `;
    
    // Append the style to the document head
    document.head.appendChild(style);
    
    // Clean up function to remove the style when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Direct scroll reset function
  useEffect(() => {
    // Force scroll to top on any route change
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };
    
    window.addEventListener('popstate', handleRouteChange);
    
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      {loading ? (
        <Loader />
      ) : (
        <Router>
          <ScrollRestoration /> {/* Add our comprehensive scroll solution */}
          <Navbar />
          <div> {/* Removed fixed top padding to allow pages to control their own spacing */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/products" element={<Products />} />
              {/* Updated routes to include services and booking */}
              <Route path="/services" element={<Products />} /> 
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/cart" element={<Cart />} />
            </Routes>
          </div>
        </Router>
      )}
    </div>
  );
};

export default App;